/* eslint-disable react/jsx-no-useless-fragment */
import { Header } from '@mantine/core';
import { FC, ReactNode, useContext } from 'react';
import LicenceHeader from '../../Atoms/LicenceHeader';
import { AuthContext } from '../../Service/Context/AuthContext';
import { WindowContext } from '../../Service/Context/WindowContext';
import { BookitupSubscriptionContext } from '../../Service/Context/BookitupSubscriptionContext';
import PrimaryHeader from './PrimaryHeader';

interface Props {
  subheader?: ReactNode;
  height?: number;
}

const PageHeader: FC<Props> = ({ subheader, height }) => {
  const { sm } = useContext(WindowContext);
  const { jwtClaims } = useContext(AuthContext);
  const { subscription } = useContext(BookitupSubscriptionContext);
  const { licence } = jwtClaims;
  const { hasUnpaidInvoices } = subscription ?? {};
  const showLicenceHeader = licence && (licence === 'BASIC' || licence === 'INTERACTIVE_TRIAL_30DAYS');
  const finalHeight =
    50 + (showLicenceHeader || hasUnpaidInvoices ? 40 : 0) + (height ?? 0) + (hasUnpaidInvoices && sm ? 10 : 0);

  return (
    <div>
      {sm ? (
        <Header height={finalHeight} sx={{ boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;' }}>
          {(showLicenceHeader || hasUnpaidInvoices) && <LicenceHeader hasUnpaidInvoices={hasUnpaidInvoices} />}
          <PrimaryHeader />
          {subheader}
        </Header>
      ) : (
        <div>
          {(showLicenceHeader || hasUnpaidInvoices) && (
            <Header height={40}>
              <LicenceHeader hasUnpaidInvoices={hasUnpaidInvoices} />
            </Header>
          )}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
